import {AnyStateMachine, StateFrom} from 'xstate';

// Extracts the matching types from the StateMachine
// This is the recommended solution from the xstate team until v5 comes out
// with improved state typing.
type StateValuesFrom<T extends AnyStateMachine> =
  StateFrom<T>['matches'] extends {
    (value: infer StateValues): unknown;
    (value: unknown): unknown;
  }
    ? StateValues
    : never;

/**
 * Generates a strongly typed selector for determining if a xstate machine
 * is currently in the specified state.
 *
 * @param stateMatcher the string or object to match
 * @returns the xstate selector
 */
export function generateSelector<T extends AnyStateMachine>(
  stateMatcher: StateValuesFrom<T>
) {
  return (state: StateFrom<T>) => state.matches(stateMatcher);
}
